import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../store/authStore';
import { roleHome, type Role } from '../lib/constants';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: Role[];
}

export default function ProtectedRoute({
  children,
  allowedRoles,
}: ProtectedRouteProps) {
  const { t } = useTranslation();
  const { isAuthenticated, isBootstrapped, user } = useAuthStore();

  // spinner finché il token non è stato verificato
  if (!isBootstrapped) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <span>{t('common.caricamento_puntini')}</span>
      </div>
    );
  }

  // Autenticato ma profilo non ancora caricato (bootstrap/login in corso): spinner,
  // NON calcolare roleHome(undefined) né rimbalzare a /login → niente blank/misroute.
  if (isAuthenticated && !user) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <span>{t('common.caricamento_puntini')}</span>
      </div>
    );
  }

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role as Role)) {
    // redirect alla home del proprio ruolo (OP → shell mobile, altri → dashboard)
    return <Navigate to={roleHome(user.role)} replace />;
  }

  return <>{children}</>;
}
